var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"status-hint",class:{isloding:_vm.loading}},[_vm._v(_vm._s(_vm.pageHint))])])}
var staticRenderFns = []

export { render, staticRenderFns }